// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/settings/v1/branding.proto" (package "c1.api.settings.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { SrcSet } from "../../assets/v1/images";
/**
 * Public API view of a branding image with responsive sources.
 *
 * @generated from protobuf message c1.api.settings.v1.BrandingImage
 */
export interface BrandingImage {
    /**
     * @generated from protobuf field: string src = 1;
     */
    src: string;
    /**
     * @generated from protobuf field: c1.api.assets.v1.SrcSet src_set = 2;
     */
    srcSet?: SrcSet;
}
/**
 * Editable branding settings (no asset versions in request/response).
 *
 * @generated from protobuf message c1.api.settings.v1.BrandingSettings
 */
export interface BrandingSettings {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
}
/**
 * Complete branding configuration with all assets and settings
 *
 * @generated from protobuf message c1.api.settings.v1.BrandingConfiguration
 */
export interface BrandingConfiguration {
    /**
     * If enabled, returns computed logo/favicon. Otherwise, fields may be empty and clients should fallback.
     *
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingImage logo_white = 3;
     */
    logoWhite?: BrandingImage; // Logo for dark backgrounds
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingImage logo = 4;
     */
    logo?: BrandingImage; // Logo for light backgrounds
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingImage favicon = 5;
     */
    favicon?: BrandingImage;
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingImage favicon_white = 6;
     */
    faviconWhite?: BrandingImage; // Favicon for dark backgrounds
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateBrandingSettingsRequest
 */
export interface UpdateBrandingSettingsRequest {
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingSettings branding_settings = 1;
     */
    brandingSettings?: BrandingSettings;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask; // update name/enabled only
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateBrandingSettingsResponse
 */
export interface UpdateBrandingSettingsResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingConfiguration branding = 1;
     */
    branding?: BrandingConfiguration;
}
/**
 * @generated from protobuf message c1.api.settings.v1.SetBrandingLogoRequest
 */
export interface SetBrandingLogoRequest {
    /**
     * @generated from protobuf field: bytes data = 1;
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.settings.v1.SetBrandingLogoResponse
 */
export interface SetBrandingLogoResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingConfiguration branding = 1;
     */
    branding?: BrandingConfiguration;
}
/**
 * @generated from protobuf message c1.api.settings.v1.SetBrandingLogoWhiteRequest
 */
export interface SetBrandingLogoWhiteRequest {
    /**
     * @generated from protobuf field: bytes data = 1;
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.settings.v1.SetBrandingLogoWhiteResponse
 */
export interface SetBrandingLogoWhiteResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingConfiguration branding = 1;
     */
    branding?: BrandingConfiguration;
}
/**
 * @generated from protobuf message c1.api.settings.v1.SetBrandingFaviconRequest
 */
export interface SetBrandingFaviconRequest {
    /**
     * @generated from protobuf field: bytes data = 1;
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.settings.v1.SetBrandingFaviconResponse
 */
export interface SetBrandingFaviconResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingConfiguration branding = 1;
     */
    branding?: BrandingConfiguration;
}
/**
 * @generated from protobuf message c1.api.settings.v1.SetBrandingFaviconWhiteRequest
 */
export interface SetBrandingFaviconWhiteRequest {
    /**
     * @generated from protobuf field: bytes data = 1;
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.settings.v1.SetBrandingFaviconWhiteResponse
 */
export interface SetBrandingFaviconWhiteResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingConfiguration branding = 1;
     */
    branding?: BrandingConfiguration;
}
/**
 * Public/unauthenticated view for pre-login and SSR consumption.
 *
 * @generated from protobuf message c1.api.settings.v1.IntrospectBrandingRequest
 */
export interface IntrospectBrandingRequest {
}
/**
 * @generated from protobuf message c1.api.settings.v1.IntrospectBrandingResponse
 */
export interface IntrospectBrandingResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingConfiguration branding = 1;
     */
    branding?: BrandingConfiguration;
}
/**
 * Tag-only ref for websocket notify / RTK invalidation.
 *
 * @generated from protobuf message c1.api.settings.v1.BrandingSettingsRef
 */
export interface BrandingSettingsRef {
}
// @generated message type with reflection information, may provide speed optimized methods
class BrandingImage$Type extends MessageType<BrandingImage> {
    constructor() {
        super("c1.api.settings.v1.BrandingImage", [
            { no: 1, name: "src", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "src_set", kind: "message", T: () => SrcSet }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.BrandingImage
 */
export const BrandingImage = new BrandingImage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BrandingSettings$Type extends MessageType<BrandingSettings> {
    constructor() {
        super("c1.api.settings.v1.BrandingSettings", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.BrandingSettings
 */
export const BrandingSettings = new BrandingSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BrandingConfiguration$Type extends MessageType<BrandingConfiguration> {
    constructor() {
        super("c1.api.settings.v1.BrandingConfiguration", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "logo_white", kind: "message", T: () => BrandingImage },
            { no: 4, name: "logo", kind: "message", T: () => BrandingImage },
            { no: 5, name: "favicon", kind: "message", T: () => BrandingImage },
            { no: 6, name: "favicon_white", kind: "message", T: () => BrandingImage }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.BrandingConfiguration
 */
export const BrandingConfiguration = new BrandingConfiguration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBrandingSettingsRequest$Type extends MessageType<UpdateBrandingSettingsRequest> {
    constructor() {
        super("c1.api.settings.v1.UpdateBrandingSettingsRequest", [
            { no: 1, name: "branding_settings", kind: "message", T: () => BrandingSettings },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateBrandingSettingsRequest
 */
export const UpdateBrandingSettingsRequest = new UpdateBrandingSettingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBrandingSettingsResponse$Type extends MessageType<UpdateBrandingSettingsResponse> {
    constructor() {
        super("c1.api.settings.v1.UpdateBrandingSettingsResponse", [
            { no: 1, name: "branding", kind: "message", T: () => BrandingConfiguration }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateBrandingSettingsResponse
 */
export const UpdateBrandingSettingsResponse = new UpdateBrandingSettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBrandingLogoRequest$Type extends MessageType<SetBrandingLogoRequest> {
    constructor() {
        super("c1.api.settings.v1.SetBrandingLogoRequest", [
            { no: 1, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SetBrandingLogoRequest
 */
export const SetBrandingLogoRequest = new SetBrandingLogoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBrandingLogoResponse$Type extends MessageType<SetBrandingLogoResponse> {
    constructor() {
        super("c1.api.settings.v1.SetBrandingLogoResponse", [
            { no: 1, name: "branding", kind: "message", T: () => BrandingConfiguration }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SetBrandingLogoResponse
 */
export const SetBrandingLogoResponse = new SetBrandingLogoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBrandingLogoWhiteRequest$Type extends MessageType<SetBrandingLogoWhiteRequest> {
    constructor() {
        super("c1.api.settings.v1.SetBrandingLogoWhiteRequest", [
            { no: 1, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SetBrandingLogoWhiteRequest
 */
export const SetBrandingLogoWhiteRequest = new SetBrandingLogoWhiteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBrandingLogoWhiteResponse$Type extends MessageType<SetBrandingLogoWhiteResponse> {
    constructor() {
        super("c1.api.settings.v1.SetBrandingLogoWhiteResponse", [
            { no: 1, name: "branding", kind: "message", T: () => BrandingConfiguration }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SetBrandingLogoWhiteResponse
 */
export const SetBrandingLogoWhiteResponse = new SetBrandingLogoWhiteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBrandingFaviconRequest$Type extends MessageType<SetBrandingFaviconRequest> {
    constructor() {
        super("c1.api.settings.v1.SetBrandingFaviconRequest", [
            { no: 1, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SetBrandingFaviconRequest
 */
export const SetBrandingFaviconRequest = new SetBrandingFaviconRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBrandingFaviconResponse$Type extends MessageType<SetBrandingFaviconResponse> {
    constructor() {
        super("c1.api.settings.v1.SetBrandingFaviconResponse", [
            { no: 1, name: "branding", kind: "message", T: () => BrandingConfiguration }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SetBrandingFaviconResponse
 */
export const SetBrandingFaviconResponse = new SetBrandingFaviconResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBrandingFaviconWhiteRequest$Type extends MessageType<SetBrandingFaviconWhiteRequest> {
    constructor() {
        super("c1.api.settings.v1.SetBrandingFaviconWhiteRequest", [
            { no: 1, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SetBrandingFaviconWhiteRequest
 */
export const SetBrandingFaviconWhiteRequest = new SetBrandingFaviconWhiteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBrandingFaviconWhiteResponse$Type extends MessageType<SetBrandingFaviconWhiteResponse> {
    constructor() {
        super("c1.api.settings.v1.SetBrandingFaviconWhiteResponse", [
            { no: 1, name: "branding", kind: "message", T: () => BrandingConfiguration }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SetBrandingFaviconWhiteResponse
 */
export const SetBrandingFaviconWhiteResponse = new SetBrandingFaviconWhiteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IntrospectBrandingRequest$Type extends MessageType<IntrospectBrandingRequest> {
    constructor() {
        super("c1.api.settings.v1.IntrospectBrandingRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.IntrospectBrandingRequest
 */
export const IntrospectBrandingRequest = new IntrospectBrandingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IntrospectBrandingResponse$Type extends MessageType<IntrospectBrandingResponse> {
    constructor() {
        super("c1.api.settings.v1.IntrospectBrandingResponse", [
            { no: 1, name: "branding", kind: "message", T: () => BrandingConfiguration }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.IntrospectBrandingResponse
 */
export const IntrospectBrandingResponse = new IntrospectBrandingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BrandingSettingsRef$Type extends MessageType<BrandingSettingsRef> {
    constructor() {
        super("c1.api.settings.v1.BrandingSettingsRef", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.BrandingSettingsRef
 */
export const BrandingSettingsRef = new BrandingSettingsRef$Type();
/**
 * @generated ServiceType for protobuf service c1.api.settings.v1.BrandingSettingsService
 */
export const BrandingSettingsService = new ServiceType("c1.api.settings.v1.BrandingSettingsService", [
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: UpdateBrandingSettingsRequest, O: UpdateBrandingSettingsResponse },
    { name: "SetBrandingLogo", options: { "authz.method": { role: "EDITOR" } }, I: SetBrandingLogoRequest, O: SetBrandingLogoResponse },
    { name: "SetBrandingLogoWhite", options: { "authz.method": { role: "EDITOR" } }, I: SetBrandingLogoWhiteRequest, O: SetBrandingLogoWhiteResponse },
    { name: "SetBrandingFavicon", options: { "authz.method": { role: "EDITOR" } }, I: SetBrandingFaviconRequest, O: SetBrandingFaviconResponse },
    { name: "SetBrandingFaviconWhite", options: { "authz.method": { role: "EDITOR" } }, I: SetBrandingFaviconWhiteRequest, O: SetBrandingFaviconWhiteResponse },
    { name: "Introspect", options: { "authz.method": { role: "REFLECTION" } }, I: IntrospectBrandingRequest, O: IntrospectBrandingResponse }
]);
